import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { homeStrings } from '@/constants/residents/strings';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

interface MarketplaceCardProps {
  onPress: () => void;
}

const SupermarketIcon = RESIDENTS_SVG_COMPONENTS.SUPERMARKET;

export const MarketplaceCard: React.FC<MarketplaceCardProps> = ({ onPress }) => {
  return (
    <TouchableOpacity 
      style={styles.card} 
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={`${homeStrings.marketplace.title}. ${homeStrings.marketplace.description}`}
    >
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <SupermarketIcon width={24} height={24} color={MARKETPLACE_COLORS.accentBlueSolid} />
        </View>
        <Text style={styles.title}>{homeStrings.marketplace.title}</Text>
        <Text style={styles.description}>
          {homeStrings.marketplace.description}
        </Text>
      </View>
      {/* Chevron positioned at top-right */}
      <Icon 
        name="chevron-forward" 
        size={24} 
        color={MARKETPLACE_COLORS.inputBorder}
        style={styles.chevron}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: MARKETPLACE_COLORS.cardBackground,
    borderRadius: 16,
    padding: 20,
    position: 'relative',
  },
  content: {
    // Content area
  },
  chevron: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
  iconContainer: {
    width: 48,
    height: 48,
    backgroundColor: MARKETPLACE_COLORS.white10Percent,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
  },
  title: {
    fontSize: 13,
    fontWeight: '700',
    color: MARKETPLACE_COLORS.textPrimary,
    marginBottom: 2,
  },
  description: {
    fontSize: 13,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textMuted,
    paddingRight: 24, // Space for chevron
  },
});
